export default function() {return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 84 63"><rect width="84" height="63" rx="4" /><path  d="M29.69,12,60.31,31.5,29.69,51V12Z" fill="#fff" /></svg>)}
